var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfrared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2086 0.477161C13.8852 0.218376 13.4132 0.270775 13.1544 0.594199C12.8957 0.917623 12.9481 1.3896 13.2715 1.64838C16.3076 4.07769 18.25 7.81182 18.25 12.0001C18.25 16.1884 16.3076 19.9226 13.2715 22.3519C12.9481 22.6107 12.8957 23.0826 13.1544 23.4061C13.4132 23.7295 13.8852 23.7819 14.2086 23.5231C17.5852 20.8214 19.75 16.6633 19.75 12.0001C19.75 7.33695 17.5852 3.17888 14.2086 0.477161Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.329 3.3099C10.9944 3.0658 10.5252 3.13919 10.2811 3.47383C10.037 3.80848 10.1104 4.27764 10.445 4.52175C12.7529 6.20518 14.25 8.9278 14.25 12.0001C14.25 15.0725 12.7529 17.7951 10.445 19.4786C10.1104 19.7227 10.037 20.1918 10.2811 20.5265C10.5252 20.8611 10.9944 20.9345 11.329 20.6904C14.0073 18.7367 15.75 15.5719 15.75 12.0001C15.75 8.42839 14.0073 5.26356 11.329 3.3099Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37554 6.15365C8.017 5.94625 7.5582 6.06877 7.3508 6.42731C7.14339 6.78586 7.26591 7.24465 7.62446 7.45206C9.19564 8.36094 10.25 10.0578 10.25 12.0001C10.25 13.9424 9.19564 15.6394 7.62446 16.5482C7.26591 16.7556 7.14339 17.2144 7.3508 17.573C7.5582 17.9315 8.017 18.0541 8.37554 17.8466C10.3912 16.6807 11.75 14.4995 11.75 12.0001C11.75 9.50077 10.3912 7.31963 8.37554 6.15365Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21V15C6.65685 15 8 13.6569 8 12C8 10.3432 6.65685 9 5 9V3C5 2.44771 4.55228 2 4 2H3C2.44772 2 2 2.44771 2 3V21C2 21.5523 2.44772 22 3 22H4C4.55228 22 5 21.5523 5 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrared);
export default __webpack_public_path__ + "static/media/infrared.54b7baf73c34294d2968ec3ae7a01e57.svg";
export { ForwardRef as ReactComponent };